const SldsProgressBar = () => {
    return (
        <div class="slds-progress-bar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="75" aria-label="Placeholder for description of progress bar" role="progressbar" >
            <span class="slds-progress-bar__value" style={{width:"75%"}}>
                <span class="slds-assistive-text">Progress: 75%</span>
            </span>
        </div>
    )
}

export default SldsProgressBar;